import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NoOpEncoder_getInstance2eh3dcptdd2fa as NoOpEncoder_getInstance } from '../internal/NoOpEncoder.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractEncoderClass;
function AbstractEncoder() {
  if (AbstractEncoderClass === VOID) {
    class $ {
      static h1s() {
        return createThis(this);
      }
      o1r(descriptor) {
        return this;
      }
      p1r(descriptor) {
      }
      i1s(descriptor, index) {
        return true;
      }
      j1s(value) {
        throw SerializationException().s1o('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      k1s() {
        throw SerializationException().s1o("'null' is not supported by default");
      }
      l1s(value) {
        return this.j1s(value);
      }
      m1s(value) {
        return this.j1s(value);
      }
      n1s(value) {
        return this.j1s(value);
      }
      o1s(value) {
        return this.j1s(value);
      }
      p1s(value) {
        return this.j1s(value);
      }
      q1s(value) {
        return this.j1s(value);
      }
      r1s(value) {
        return this.j1s(value);
      }
      s1s(value) {
        return this.j1s(new (Char())(value));
      }
      t1s(value) {
        return this.j1s(value);
      }
      u1s(enumDescriptor, index) {
        return this.j1s(index);
      }
      v1s(descriptor) {
        return this;
      }
      w1s(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.l1s(value);
        }
      }
      x1s(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.m1s(value);
        }
      }
      y1s(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.n1s(value);
        }
      }
      z1s(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.o1s(value);
        }
      }
      a1t(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.p1s(value);
        }
      }
      b1t(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.q1s(value);
        }
      }
      c1t(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.r1s(value);
        }
      }
      d1t(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.s1s(value);
        }
      }
      e1t(descriptor, index, value) {
        if (this.i1s(descriptor, index)) {
          this.t1s(value);
        }
      }
      f1t(descriptor, index) {
        return this.i1s(descriptor, index) ? this.v1s(descriptor.a1q(index)) : NoOpEncoder_getInstance();
      }
      g1t(descriptor, index, serializer, value) {
        if (this.i1s(descriptor, index)) {
          this.h1t(serializer, value);
        }
      }
      i1t(descriptor, index, serializer, value) {
        if (this.i1s(descriptor, index)) {
          this.j1t(serializer, value);
        }
      }
    }
    protoOf($).k1t = encodeNotNullMark;
    protoOf($).l1t = beginCollection;
    protoOf($).h1t = encodeSerializableValue;
    protoOf($).j1t = encodeNullableSerializableValue;
    protoOf($).m1t = shouldEncodeElementDefault;
    initMetadataForClass($, 'AbstractEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    AbstractEncoderClass = $;
  }
  return AbstractEncoderClass;
}
//region block: exports
export {
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
};
//endregion

//# sourceMappingURL=AbstractEncoder.mjs.map
